import { useSelector } from 'react-redux';
import { getDealType } from '../../../selectors';
import { EDealType } from '../../../types/share';

import { CATEGORY_RENT, CATEGORY_SALE } from '../../../constants/filters';

export function useGetValuesForCategory() {
  const dealType = useSelector(getDealType);

  if (dealType === EDealType.Rent) {
    return CATEGORY_RENT;
  }

  return CATEGORY_SALE;
}
